import React, { useState, useCallback } from 'react';
import { Button, Stack } from '@moda/om';
import { useForm } from '../../../hooks/useForm';
import { ShippingAddressValidationPopup } from '../ShippingAddressValidationPopup';
import {
  RestAddressAttributesData,
  RestAddressData,
  ShippingAddressMutationError
} from '../../../hooks/useAddress';
import { FormButtonsLayout } from '../../FormButtonsLayout';
import { ShippingAddressFormFields } from '../ShippingAddressFormFields';
import { validations } from './validations';

interface Props {
  address: RestAddressData | undefined;
  mutationFieldErrors: ShippingAddressMutationError;
  onCancel: (() => void) | undefined;
  onSubmit: (address: RestAddressAttributesData, id: string | undefined) => void;
}

export const ShippingAddressForm: React.FC<Props> = ({
  address,
  mutationFieldErrors,
  onSubmit,
  onCancel
}) => {
  const [validatingAddress, setValidatingAddress] = useState<RestAddressAttributesData | undefined>(
    undefined
  );

  const handleModalClose = useCallback(() => {
    setValidatingAddress(undefined);
  }, []);

  const { handleSubmit: handleSubmitForValidation, errors: validationErrors } = useForm({
    onSubmit: setValidatingAddress,
    validations
  });

  const handleSubmit = useCallback(
    (addressAttributes: RestAddressAttributesData) => {
      setValidatingAddress(undefined);
      onSubmit(addressAttributes, address?.id);
    },
    [address, onSubmit]
  );

  return (
    <>
      <form className="ShippingAddressForm" onSubmit={handleSubmitForValidation}>
        <Stack space={4}>
          <ShippingAddressFormFields
            address={address}
            mutationFieldErrors={mutationFieldErrors}
            validationErrors={validationErrors}
          />
          <FormButtonsLayout>
            {onCancel && (
              <Button onClick={onCancel} secondary type="button">
                Cancel
              </Button>
            )}
            <Button type="submit">Continue</Button>
          </FormButtonsLayout>
        </Stack>
      </form>
      {validatingAddress && (
        <ShippingAddressValidationPopup
          address={validatingAddress}
          onSubmit={handleSubmit}
          onPopupClose={handleModalClose}
        />
      )}
    </>
  );
};
